import { useMutation } from "react-query";
import { axiosInstance } from "../../config/axios";
import { BaseResponse } from "../_types";
import { GetSalesmanSummaryRequest, ISalesmanSummary } from "./types";

export const getSalesmanSummary = async (params: GetSalesmanSummaryRequest): Promise<BaseResponse<ISalesmanSummary>> => {
    const response = await axiosInstance.get<BaseResponse<ISalesmanSummary>>(
        "/SalesmanBonus/GetSummary",
        { params }
    );
    return response.data;
};

export function useGetSalesmanSummary() {
    return useMutation<BaseResponse<ISalesmanSummary>, Error, GetSalesmanSummaryRequest>(
        (variables) => getSalesmanSummary(variables)
    );
}
